<button class="btn btn-icon btn-close btn-transparent" (click)="rightPanelService.close()">
    <sb-inline-svg
        class="icon icon-close"
        aria-label="My icon"
        [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/X icon.svg'"></sb-inline-svg>
</button>

@switch (rightPanelService.type) {
    @case (rightPanelTypeEnum.user) {
        <app-user-info [user]="rightPanelService.data.user" [userId]="rightPanelService.data.userId" />
    }

    @case (rightPanelTypeEnum.redactTicket) {
        <app-redact-ticket [ticket]="rightPanelService.data.ticket" />
    }

    @case (rightPanelTypeEnum.hideTicketContent) {
        <app-hide-ticket-content
            [ticket]="rightPanelService.data.ticket"
            [replyId]="rightPanelService.data.replyId"
            [hidingText]="rightPanelService.data.hidingText" />
    }

    @case (rightPanelTypeEnum.voyado) {
        <app-voyado [email]="rightPanelService.data.email" />
    }

    @case (rightPanelTypeEnum.groupInfo) {
        <app-group-info [groupId]="rightPanelService.data.groupId" />
    }
}
